import type { RoundRevealPayload } from "@hitster/shared";
import { GameModal } from "./GameModal";

interface Props {
  reveal: RoundRevealPayload;
  playerNickname: string;
  open: boolean;
  /** Joueur ayant posé la carte — seul autorisé à faire avancer la partie. */
  canContinue: boolean;
  /** Victoire atteinte mais la partie continue pour les autres. */
  continueAfterWin?: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export function RevealPanel({ reveal, playerNickname, open, canContinue, continueAfterWin, onClose, onContinue }: Props) {
  return (
    <GameModal open={open} onClose={canContinue ? undefined : onClose} labelledBy="reveal-title">
      {reveal.song.coverImageUrl && (
        <img src={reveal.song.coverImageUrl} alt="" className="w-32 h-32 mx-auto rounded-xl object-cover" />
      )}
      <p className="text-sm text-violet-400">{playerNickname}</p>
      <h3 id="reveal-title" className="cw-title text-2xl font-bold">{reveal.song.title}</h3>
      <p className="text-violet-300">{reveal.song.artist}</p>
      <p className="text-4xl font-extrabold text-orange-400">{reveal.song.releaseYear}</p>
      <p className={`text-lg font-semibold ${reveal.correct ? "text-green-400" : "text-red-400"}`}>
        {reveal.correct ? "Carte réussie !" : "Carte ratée — rejetée"}
      </p>
      <div className="flex justify-center pt-2">
        {canContinue ? (
          <button type="button" className="cw-btn cw-btn-primary" onClick={onContinue}>
            {continueAfterWin ? "Continuer la partie" : "Continuer"}
          </button>
        ) : (
          <button type="button" className="cw-btn cw-btn-secondary" onClick={onClose}>
            Fermer
          </button>
        )}
      </div>
    </GameModal>
  );
}
